import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SeeMoreButton from '../seeMoreButton/SeeMoreButton';
import './ExpandCollapsWrapper.scss';

const ExpandCollapsWrapper = ({ groupId, children, moreButtonText, toggleHandler, lrsGroup }) => {
    const [isExpanded, setExpanded] = useState(false);
    const staticContent = children[0];
    const dynamicContent = children[1];
    const handleToggleSection = () => {
        toggleHandler(!isExpanded, lrsGroup);
        setExpanded(!isExpanded);
    };
    return (
        <div
            data-tour-step={`see-activities-${groupId}`}
            data-tour-allow-interaction
            className="expand-collaps-wrapper"
        >
            {staticContent}
            {isExpanded && dynamicContent}
            <SeeMoreButton
                moreButtonText={moreButtonText}
                isExpanded={isExpanded}
                onClick={handleToggleSection}
            />
        </div>
    );
};

ExpandCollapsWrapper.defaultProps = {
    children: [],
    moreButtonText: 'See more',
    toggleHandler: () => {},
    groupId: 1,
    lrsGroup: '',
};

ExpandCollapsWrapper.propTypes = {
    children: PropTypes.array,
    moreButtonText: PropTypes.string,
    toggleHandler: PropTypes.func,
    groupId: PropTypes.number,
    lrsGroup: PropTypes.string,
};

export default ExpandCollapsWrapper;
